import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { Link } from 'react-router-dom';
import { ResponsiveRadar } from '@nivo/radar';
import { Notification, Space } from '@mantine/core';

import moment from 'moment';
import history from '../../history';
import Progress from '../partials/Progress';
import ContainerTranslation from "../partials/ContainerTranslation";
import Popup from "../partials/SelectDocPopup";
import ProjectList from '../project/ProjectList';
import { createProjectForConsultant } from '../../actions/project';
import { fetchConsultant, uploadPicture, downloadFieldImageConsultant, submitField2Approver, approveField, rejectField, expireField } from '../../actions/consultant';
import { getUsersList } from '../../actions/user';
import { extractConsultant } from '../../actions/consultant';

import { SelectLabeled } from '../input/SelectLabeled.tsx';



const ImplicationRadar = ({ data /* see data tab */ }) => (
  <ResponsiveRadar
    data={data}
    keys={["Level"]}
    indexBy="implicationIndex"
    maxValue="auto"
    margin={{ top: 40, right: 80, bottom: 50, left: 80 }}
    curve="linearClosed"
    borderWidth={2}
    borderColor={{ from: 'color' }}
    gridLevels={5}
    gridShape="circular"
    gridLabelOffset={16}
    enableDots={true}
    dotSize={5}
    dotColor={{ theme: 'background' }}
    dotBorderWidth={1}
    dotBorderColor={{ from: 'color' }}
    enableDotLabel={false}
    dotLabel="value"
    dotLabelYOffset={-12}
    colors={{ scheme: 'nivo' }}
    fillOpacity={0.25}
    blendMode="multiply"
    animate={true}
    motionStiffness={90}
    motionDamping={15}
    isInteractive={false}
  />
)



class ConsultantView extends React.Component {

  constructor(props) {
    
    super(props);

    this.state = {
      isPopupOpen: false,
      popUpShowExtensionError: false,
      approverPromptPopup:false,
      selectedSkill:null,
      selectedApprover:null
    }
    this.user = JSON.parse(localStorage.getItem("user"))
    this.props.getUsersList();
    this.props.fetchConsultant(this.props.match.params.id);
    
  }


  componentDidMount() {
    window.scrollTo(0, 0);

    if (!this.props.consultant) {
      return
    }

    if (this.props.consultant.projects) {
      this.props.consultant.projects = this.props.consultant.projects.sort((a, b) => { return moment(a.content.information["start-date"], "DD/MM/YYYY").isAfter(moment(b.content.information["start-date"], "DD/MM/YYYY")) ? -1 : 1; })
    } 

    if (this.props.consultant.content && this.props.consultant.content.school) {
      this.props.consultant.content.school = this.sortSchools(this.props.consultant.content.school)
    }

  }

  componentDidUpdate(prevProps) {

    if (!this.props.consultant) {
      return
    }

      if (this.props.projectMessage === 'Created project' &&  this.props.documentId) {
        history.push('/project/edit/' + this.props.documentId);
    }
  }


  handleApproverPromptPopupClose(){
    this.setState({approverPromptPopup:false,selectedSkill:null})
  }

  handleClose = () => {
    this.setState({ popUpShowExtensionError: false });
  };

  handleSubmitField2Approver(){
    this.props.submitField2Approver(this.props.match.params.id,this.state.selectedSkill,this.state.selectedApprover.value)
  }


    handleCompetencyApprovalFactory(path, isApprover) {
        let competencyApprovalHandlers = {};

        if (this.user.group !== "aegis") {
            return competencyApprovalHandlers;
        };

        const [field, fieldIndex] = path.split('.')

        if (
            this.props.consultant.validationInformation.content[field][fieldIndex]
            && this.props.consultant.validationInformation.content[field][fieldIndex].validationStatus === "document_validation_status_validated"
        ) {
            const handleExpire = () => {
                this.props.expireField(this.props.match.params.id, path, this.user._id);
            };
            competencyApprovalHandlers.approverPrompt = { label: 'Expire competencies', action: handleExpire };
        }


        if (this.props.consultant.validationInformation.validationStatus !== "document_validation_status_submitted") {
            return competencyApprovalHandlers;
        };




        if (isApprover) {
            const handleApprove = () => {
                this.props.approveField(this.props.match.params.id, path, this.user._id);
            };
            const handleReject = () => {
                this.props.rejectField(this.props.match.params.id, path, this.user._id);
            };

            competencyApprovalHandlers.approving = { label: 'Approve', action: handleApprove };
            competencyApprovalHandlers.rejecting = { label: 'Reject', action: handleReject };
        };

        
        


        if (this.props.consultant.authorization.validate) {
            const handleApproverPromptPopup = () => {
                this.setState({ approverPromptPopup: true, selectedSkill: path });
            };
            competencyApprovalHandlers.approverPrompt = { label: 'Request for approval', action: handleApproverPromptPopup };
        } 

        return competencyApprovalHandlers

    }


  uploadPicture(files) {
    if (files[0]) {
      const acceptedExtensions = [".png", ".jpg", ".jpeg"];
      const extension = files[0].name.substring(files[0].name.lastIndexOf("."));
      const isValidExtension = acceptedExtensions.find((m) => m === extension) != null;
      if(isValidExtension){
        this.setState({ popUpShowExtensionError: false });
        this.props.uploadPicture(files[0], this.props.match.params.id)
      } else {
        this.setState({ popUpShowExtensionError: true });
      }
    }
  }

  downloadFieldImageConsultant(getter) {
    this.props.downloadFieldImageConsultant(getter,this.props.match.params.id)

    }

    downloadDocumentFactory(name, parent, index) {
        function downloadDocument() {
            const getter = { name: name, parent: parent, index: index };
            this.props.downloadFieldImageConsultant(getter, this.props.match.params.id)
        }
        return downloadDocument
    }

  extractConsultant(){
    this.props.extractConsultant(this.props.consultant._id,this.props.languages.findIndex((l) => l.active));

  }


  sortSchools(schools){
    schools = schools.sort((b, a) => {
      if(isFinite(a['school-year']-b['school-year'])) {
        return a['school-year']-b['school-year']; 
      } else {
        return isFinite(b['school-year']) ? -1 : 1;
      }
    })
    return schools
  }

  renderProjects() {
    return (
        <ProjectList items={this.props.consultant.projects} small={false} circle={true} translate={this.props.translate} endpoint={"/project/"} />
    );
  }


  renderImplicationRadar() {
    let implicationData = []

      let implication = this.props.consultant.content.implication
      implicationData = [
        {
          "implicationIndex": this.props.translate("content.implication." + ["Business"] + "." + ["title"]),
          "Level": implication.Business ? implication.Business.length : null,
        },
        {
          "implicationIndex": this.props.translate("content.implication." + ["Innovation"] + "." + ["title"]),
          "Level": implication.Innovation ? implication.Innovation.length : null,
        },
        {
          "implicationIndex": this.props.translate("content.implication." + ["Management"] + "." + ["title"]),
          "Level": implication.Management ? implication.Management.length : null,
        },
        {
          "implicationIndex": this.props.translate("content.implication." + ["Training"] + "." + ["title"]),
          "Level": implication.Training ? implication.Training.length : null,
        }
      ]
    return <ImplicationRadar data={implicationData} />
  }

  renderEnvironnement() {
    let railway = []
    let energy = []
    if (this.props.consultant.content.environnement['environnement-domain'].Railway>0){
      let experience = this.props.consultant.content.environnement['environnement-domain'].Railway
      railway.push(
        <p key={"Railway"} className="bloc-tag" style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
          <i className="fas fa-train" style={{ marginRight: "10px" }}></i><ContainerTranslation id={['secteur'] + "." + ["Railway"]} /> - {experience} <ContainerTranslation id={'years'} />
        </p>
      )
    }
    if (this.props.consultant.content.environnement['environnement-domain'].Energy>0){
      let experience = this.props.consultant.content.environnement['environnement-domain'].Energy
      energy.push(
        <p key={"Energy"} className="bloc-tag" style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
          <i className="fas fa-train" style={{ marginRight: "10px" }}></i><ContainerTranslation id={['secteur'] + "." + ["Energy"]} /> - {experience} <ContainerTranslation id={'years'} />
        </p>
      )
    }

    Object.entries(this.props.consultant.content.environnement['environnement-context']["Railway"]).forEach(([key,value]) =>{
        if (!value || value === '0' ){
        return
      }
      railway.push(
        <p key={key} className="bloc-tag" style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
          <ContainerTranslation id={['context'] + "." + [key]} /> - {value} <ContainerTranslation id={'years'} />
        </p>
      )
    })

    Object.entries(this.props.consultant.content.environnement['environnement-context']["Energy"]).forEach(([key,value]) =>{
        if (!value ||  value === '0'){
        return
      }
      energy.push(
        <p key={key} className="bloc-tag" style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
          <ContainerTranslation id={['context'] + "." + [key]} /> - {value} <ContainerTranslation id={'years'} />
        </p>
      )
    })




    return (
      <div>
        <div style={{ display: 'block' }}>
            {railway}
        </div>
        <div style={{ display: 'block', marginTop: 30 }}>
            {energy}
        </div>
      </div>
    )
  }


  renderTitle(title) {


    return (
      <>
        {typeof title === 'object' ?
          <h2  style={{ marginLeft: 5, fontSize: 18, marginBottom: 0, color: "#eb4f1e" }}>
            {title["title1"] ? <span ><ContainerTranslation id={title['title1']} /></span> : null}
            {title["title2"] ? <span ><i className="fas fa-angle-right" style={{ color: '#989DA3', verticalAlign: 'top', margin: '3px 5px 2px 5px' }}></i><ContainerTranslation id={title['title2']} /></span> : null}
            {title["experience"] ? <span ><i className="fas fa-angle-right" style={{ color: '#989DA3', verticalAlign: 'top', margin: '3px 5px 2px 5px' }}></i>{title["experience"]}</span> : null}
          </h2>
          :
          <span>{title}</span>
        }
      </>
    );
  }

  createProject() {
    const editor = {
      firstName: this.props.consultant.user.sageContent.profile.firstName,
      lastName: this.props.consultant.user.sageContent.profile.lastName,
      _id: this.props.consultant.user._id
    }
    this.props.createProjectForConsultant(editor)
  }


  togglePopup() {
    this.setState({isPopupOpen: !this.state.isPopupOpen})
  }

    truncate(path) {
        const maxChar = 35;

        let name = [];
        if (path.length === 1) {
          return path[0].length > maxChar ? [`... ${path[0].slice(0,maxChar)}`] : path 
        }

        name = path.reduceRight((name, level) => {
            if (name[0] === "...") {
                return name
            }
            if (level.length > maxChar && name.length === 0) {
                name.unshift(`${level.slice(0, maxChar)} ...`)
                name.unshift("...")
                return name
            }
            if (name.reduce((length, x) => length + x.length, 0) + level.length > maxChar) {
                name.unshift("...")
                return name
            }
            name.unshift(level)
            return name
        }, []) 
        return name
    }


  render() {


    if (Object.keys(this.props.consultant).length === 0 || Object.keys(this.props.list).length === 0) {
      return null
    }


    const route = this.props.consultant.authorization.write ? `/consultant/edit/${this.props.consultant._id}` : null;
    const traductionEdit = this.props.consultant.authorization.write ? 'btn-edit-consultant' : 'btn-edit'


    let title = "";
    if (this.props.consultant.content["information-consultant"]["custom-title"] && this.props.consultant.content["information-consultant"]["custom-title"] !== ""){
      title = this.props.consultant.content["information-consultant"]["custom-title"]
    }else{
      title = this.props.consultant.title
    }
    

    // .client.level_1.value

    let tmp = this.props.consultant.projects.map(project => project.content.client.level_1 ? project.content.client.level_1.value : "").filter((x) => x !== '')

    const clients = [...new Set(tmp)] 
     
    
    const progression_array = this.props.consultant.projects.map((n) => {return n.progression ? n.progression : 0});
    const total = progression_array.reduce((total,n) => total + n, 0);
    const projectsMeanProgression = total/this.props.consultant.projects.length;

    


      const actionHandlersFactory = this.handleCompetencyApprovalFactory.bind(this)


    const toolSkills = this.props.consultant.content.tools.filter((tool)=>tool).map((tool, i) => {

        const validationStatus = this.user.group !== "aegis" ? undefined : {
            ...this.props.consultant.validationInformation.content.tools[i],
            user: this.props.list.users[this.props.consultant.validationInformation.content.tools[i].user]
        }

      return {
        name : this.truncate([tool.name]),
        fullName : tool.name,
        level : tool.expertise,
        yearOfExperience : tool.experience,
        justification : tool.justification,
        validationStatus: validationStatus,
          actionhandlers: actionHandlersFactory(`tools.${i}`, this.props.consultant.validationInformation.content.tools[i].user === this.user._id),
          downloadDocument: tool['document'] ? this.downloadDocumentFactory("document", "tools", i).bind(this) : null
      }
    })

      const technicalSkills = this.props.consultant.content.expertise.filter((expertise) => expertise).map((expertise, i) => {

      const level_1 = this.props.translate(`domain-competence.${expertise['domain-competence']}`);
        const level_2 = expertise['domain-competence'] ? this.props.translate(`domain-speciality.${expertise['domain-competence']}.${expertise['domain-speciality']}`) : "";
      const level_3 = expertise['domain-competence'] && expertise['domain-speciality'] ? this.props.translate(`domain-specificity.${expertise['domain-speciality']}.${expertise['domain-specificity']}`) : "";
        const fullPath = [level_1, level_2, level_3].filter((x) => x);
      

        const validationStatus = this.user.group !== "aegis" ? undefined : {
            ...this.props.consultant.validationInformation.content.expertise[i],
            user: this.props.list.users[this.props.consultant.validationInformation.content.expertise[i].user]
        }

      return {
          name: this.truncate(fullPath).join(' > '),
        fullName : fullPath.join(' > '),
        level : expertise['expertise'],
        yearOfExperience : expertise['domain-experience'],
        justification : expertise.justification,
          validationStatus: validationStatus,
          actionhandlers: actionHandlersFactory(`expertise.${i}`, this.props.consultant.validationInformation.content.expertise[i].user === this.user._id),
          downloadDocument: expertise['domain-document'] ? this.downloadDocumentFactory("domain-document", "expertise", i).bind(this) : null
      }
    })


    const engineeringSkills = this.props.consultant.content.engineering.filter((skill)=>skill).map((skill, i) => {

      const level_1 = this.props.translate(`engineering-skill.${skill['engineering-skill']}`);
      const level_2 = skill['engineering-skill'] ? this.props.translate(`engineering-specialization.${skill['engineering-skill']}.${skill['engineering-specialization']}`) : "";
      const fullPath = [level_1,level_2].filter((x)=> x);

        const validationStatus = this.user.group !== "aegis" ? undefined : {
            ...this.props.consultant.validationInformation.content.engineering[i],
            user: this.props.list.users[this.props.consultant.validationInformation.content.engineering[i].user]
        }


      return {
          name: this.truncate(fullPath).join(' > '),
        fullName : fullPath.join(' > '),
        level : skill['expertise'],
        yearOfExperience : skill['engineering-experience'],
        justification : skill.justification,
          validationStatus: validationStatus,
          actionhandlers: actionHandlersFactory(`engineering.${i}`, this.props.consultant.validationInformation.content.engineering[i].user === this.user._id),
          downloadDocument: skill['engineering-document'] ? this.downloadDocumentFactory("engineering-document", "engineering", i).bind(this) : null
      }
    })

    const operationalSkills = this.props.consultant.content['intervention-level'].filter((intervention)=>intervention).map((intervention, i) => {

      const level_1 = this.props.translate(`intervention-type.${intervention['intervention-type']}`);
      const level_2 = intervention['intervention-type'] ? this.props.translate(`intervention-mission.${intervention['intervention-type']}.${intervention['intervention-mission']}`) : "";
      const level_3 = intervention['intervention-type'] && intervention['intervention-mission'] ? this.props.translate(`intervention-application.${intervention['intervention-mission']}.${intervention['intervention-application']}`) : "";
      const level_4 = intervention['intervention-type'] && intervention['intervention-mission'] && intervention['intervention-application'] ? intervention['level-4'] : "";
      const fullPath = [level_1,level_2,level_3,level_4].filter((x)=> x);


        const validationStatus = this.user.group !== "aegis" ? undefined : {
            ...this.props.consultant.validationInformation.content['intervention-level'][i],
            user: this.props.list.users[this.props.consultant.validationInformation.content['intervention-level'][i].user]
        }

      return {
          name: this.truncate(fullPath).join(' > '),
        fullName : fullPath.join(' > '),
        level : intervention['expertise'],
        yearOfExperience : intervention['intervention-experience'],
        justification : intervention.justification,
          validationStatus: validationStatus,
          actionhandlers: actionHandlersFactory(`intervention-level.${i}`, this.props.consultant.validationInformation.content['intervention-level'][i].user === this.user._id),
          downloadDocument: intervention['intervention-document'] ? this.downloadDocumentFactory("intervention-document", "intervention-level", i).bind(this) : null
      }
    })

      const accreditationBodySkills = this.user.group !== "aegis" ? undefined : this.props.consultant.content['accreditation-body'].filter((skill) => skill).map((skill, i) => {

          const level_1 = this.props.translate(`level-1.${skill['level-1']}`);
          const level_2 = skill['level-1'] ? this.props.translate(`level-2.${skill['level-1']}.${skill['level-2']}`) : "";
          const level_3 = skill['level-1'] && skill['level-2'] ? this.props.translate(`level-3.${skill['level-2']}.${skill['level-3']}`) : "";
          const level_4 = skill['level-1'] && skill['level-2'] && skill['level-3'] ? skill['level-4'] : "";
          const fullPath = [level_1, level_2, level_3, level_4].filter((x) => x);


          const validationStatus = {
              ...this.props.consultant.validationInformation.content['accreditation-body'][i],
              user: this.props.list.users[this.props.consultant.validationInformation.content['accreditation-body'][i].user]
          }

          return {
              name: this.truncate(fullPath).join(' > '),
              fullName: fullPath.join(' > '),
              level: skill['expertise'],
              yearOfExperience: skill['experience'],
              justification: skill.justification,
              validationStatus: validationStatus,
              actionhandlers: actionHandlersFactory(`accreditation-body.${i}`, this.props.consultant.validationInformation.content['accreditation-body'][i].user === this.user._id),
              downloadDocument: skill['accreditation-document'] ? this.downloadDocumentFactory("accreditation-document", "accreditation-body", i).bind(this) : null
          }
      })

      const selectApprover = this.state.selectedApprover ? { value: this.state.selectedApprover.value, label: this.state.selectedApprover.label } : []




    return (
      <> {this.state.isPopupOpen ? <Popup
        content={<>
          <div style={{ textAlign: 'center', margin: '10px'}}><b> <ContainerTranslation id={['Export'] + "." + ['Selection']  } /> </b></div>
          <div style={{ textAlign: 'center', margin: '10px'}}>      
            <div className="extractor_extern" >
              <button onClick={this.extractConsultant.bind(this)} >   <ContainerTranslation id={['Export'] + "." + ['Button pop up 1']  } />    </button>
            </div>
          </div>
        </>}
        handleClose={this.togglePopup.bind(this)}
      /> :
      null}
      {this.state.approverPromptPopup ? <Popup
        content={<>
          <div style={{ textAlign: 'center', margin: '10px'}}><b> <ContainerTranslation id={['Export'] + "." + ['Selection']  } /> </b></div>
                    <div style={{ width: '80%', margin: 'auto' }}>
                        <SelectLabeled
                            value={selectApprover}
                            onChange={(obj) => { this.setState({ selectedApprover: obj }) }}
                            options={Object.keys(this.props.list.users).map((id) => { return { label: this.props.list.users[id], value: id } })}
                        />
          </div>
          <div style={{ textAlign: 'center', margin: '10px'}}>
            <div className="extractor_extern" >
              <button onClick={this.handleSubmitField2Approver.bind(this)} >   Send request to approver    </button>
            </div>
          </div>
        </>}
        handleClose={this.handleApproverPromptPopupClose.bind(this)}
      /> :
      null}   
      <div className="dashboard">     
          <div>
            <div className="dashboard-header">
              <div style={{width: 'calc(100% - 200px)'}}>
                <Progress progression={this.props.consultant.progression.globalPercentage} 
                          validationInformation = {{...this.props.consultant.validationInformation,validator:this.props.consultant.validator}} 
                          kind = "Consultant"
                          gender = {this.props.consultant.user.sageContent.profile.gender}
                          title = {this.props.consultant.user.sageContent.profile.firstName + " " + this.props.consultant.user.sageContent.profile.lastName}
                />
              </div>
              <div style={{flex : 1}}> 
                {route ?
                  <Link className="primary-btn filling" style={{float:"right",width:"110px",height:"48px", lineHeight:"normal"}} to={route}>
                    <ContainerTranslation id={['Page'] + "." + ['Consultant'] + "." + ['ConsultantView'] + "." + [traductionEdit]} />
                  </Link>
                  :
                  null
                }
                <div className="extractor_extern" >
                  <button className="primary-btn filling" style={{float:"right",width:"156px",height:"48px"}} onClick={this.togglePopup.bind(this)} >   <ContainerTranslation id={['Export'] + "." + ['Extract Button']  } />    </button>
                </div>
              </div>
            </div>            

                    <div className="dashboard-content">

                        {/*LEFT PART*/}



                        <div className="col-1-3" style={{ marginRight: '10px', marginLeft: 0, paddingTop: '20px' }}>
                            <div className="bloc-content" style={{ color: '#181E23', display: 'flex', justifyContent: 'center' }}>

                            </div>

                            {/*PICTURE*/}
                            {this.props.consultant.picture64 ?
                                <img src={this.props.consultant.picture64} width="100%" alt="consultant" />
                                :
                                null
                            }
                            {this.props.consultant.authorization.picture ?
                                <div className="input-container files" style={{ textAlign: 'center', marginTop: '10px' }}>
                                    <label htmlFor='picture'><ContainerTranslation id={"Page." + ['Consultant'] + "." + ['ConsultantView'] + "." + ['Edit Profile Picture']} /></label>
                                    <input type="file"
                                        style={{ display: "none" }}
                                        onChange={(e) => this.uploadPicture(e.target.files)}
                                        id='picture' />
                                </div>
                                :
                                null
                            }

                            {/*POP UP EXTENSION ERROR*/}
                            {this.state.popUpShowExtensionError ?
                                <>
                                    <Space h="md" />
                                    <Notification color="red" title={this.props.translate("feedBack.NotificationPicture.title")} onClose={() => this.handleClose()}>
                                        <Space h="xs" />
                                        {this.props.translate("feedBack.NotificationPicture.contexte1")}
                                        <Space h="xs" />
                                        {this.props.translate("feedBack.NotificationPicture.contexte2")}
                                    </Notification>
                                </> : <></>}

                            {/*INFORMATION*/}
                            <div className="bloc-content">
                                <p className="bloc-content" style={{ marginBottom: 0 }}>
                                    <i className="fas fa-user"></i> Manager
                                </p>
                                {this.props.consultant.user.manager}
                            </div>
                            <p className="bloc-content">
                                <i className="fas fa-map-marker-alt" style={{ marginRight: '10px' }}></i> {this.props.consultant.user.filiale.country} - {this.props.consultant.user.filiale.city}
                            </p>
                            {this.props.consultant.projects.length > 0 ?
                                <>
                                    <div className="bloc">
                                        <span>clients</span>
                                        <div>
                                            {clients.map(client => <p className="bloc-tag" key={Date.now() + "-" + client}>{client} </p>)}
                                        </div>
                                    </div>
                                    <div className="bloc">
                                        <span>{this.props.consultant.projects.length} <ContainerTranslation id={"Page." + ['Consultant'] + "." + ['ConsultantView'] + "." + ['project(s)']} /></span>
                                        <div>
                                            <Progress progression={projectsMeanProgression}
                                                validationInformation={this.props.consultant.validationInformation}
                                                kind="Project"
                                                title={this.props.translate("nav." + ['Mean progression'])}
                                                hideIcon={true}
                                            />
                                        </div>
                                        {this.renderProjects()}
                                    </div>
                                </>
                                :
                                null
                            }
                            {(route && this.props.consultant.authorization.create) ?
                                <div className="bloc-content" style={{ color: '#181E23', display: 'flex', justifyContent: 'center' }}>
                                    <button
                                        className="primary-btn"
                                        onClick={this.createProject.bind(this)}>
                                        <ContainerTranslation id={'Page.Project.btn-add'} />
                                    </button>
                                </div>
                                :
                                null
                            }

                        </div>

                        {/*RIGHT PART*/}

                        <div className="col-2-3" style={{ marginLeft: '10px', marginRight: 0 }}>
                            {/*TITRE*/}
                            {this.renderTitle(title)}
                            {/*IMPLICATION RADAR*/}
                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['implication'] + ".title"} tag={"span"} />
                                <div className="tile" style={{ width: 'calc(100%)', padding: '0', height: '280px' }}>
                                    {this.renderImplicationRadar()}
                                </div>
                            </div>
                            {/*ENVIRONNEMENT*/}
                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['environnement'] + ".title"} tag={"span"} />
                                {this.renderEnvironnement()}
                            </div>

                            {/*TECHNICAL_SKILL*/}
                            <SkillFields
                                skills={technicalSkills}
                                name={'expertise'}
                                translate={this.props.translate}
                                users={this.props.list.users}
                            />

                            {/*ACCREDITATION-SKILLS*/}
                            {this.user.group !== "aegis" ? null :
                                <SkillFields
                                    skills={accreditationBodySkills}
                                    name={'accreditation-body'}
                                    translate={this.props.translate}
                                    users={this.props.list.users}
                                />}

                            {/*OPERATIONAL-SKILLS*/}
                            <SkillFields
                                skills={operationalSkills}
                                name={'intervention-level'}
                                translate={this.props.translate}
                                users={this.props.list.users}
                            />


                            {/*ENGINEERING-SKILLS*/}
                            <SkillFields
                                skills={engineeringSkills}
                                name={'engineering'}
                                translate={this.props.translate}
                                users={this.props.list.users}
                            />

                            {/*METHODS AND TOOLS*/}
                            <SkillFields
                                skills={toolSkills}
                                name={'tools'}
                                translate={this.props.translate}
                                users={this.props.list.users}
                            />


                            {/*ACADEMIC BACKGROUND*/}
                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['school'] + ".title"} tag={"span"} />
                                {this.props.consultant.content['school'].map((school, i) =>
                                    <div key={Date.now() + "-" + i} style={{ display: 'block' }}>
                                        <p className="bloc-content">
                                            {school['school-document'] !== "" ? <div
                                                style={{ display: "inline" }}
                                                onClick={(e) => this.downloadFieldImageConsultant({ name: "school-document", parent: "school", index: i })}
                                            ><i className="fas fa-graduation-cap"
                                                title={this.props.translate('content.school.diploma.download')}
                                                style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "red" }}
                                                />
                                            </div>
                                                :
                                                <i className="fas fa-graduation-cap" style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px' }}></i>}
                                            {school['school-name']}
                                            {school['school-diplome'] ?
                                                <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{school['school-diplome']}</>
                                                :
                                                null
                                            }
                                            {school['school-year'] ?
                                                <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{school['school-year']}</>
                                                :
                                                null
                                            }
                                        </p>
                                    </div>)}
                            </div>

                            {/*FORMATION*/}

                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['formation'] + ".title"} tag={"span"} />
                                {this.props.consultant.content['formation'].map((formation, i) =>
                                    <div key={Date.now() + "-" + formation + i} style={{ display: 'block' }}>
                                        {formation['formation-document'] !== "" && formation['formation-document'] !== undefined ? <div
                                            style={{ display: "inline" }}
                                            onClick={(e) => this.downloadFieldImageConsultant({ name: "formation-document", parent: "formation", index: i })}
                                        ><i className="fas fa-clipboard-check"
                                            title={this.props.translate('content.school.diploma.download')}
                                            style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "red" }}
                                            />
                                        </div>
                                            :
                                            <i className="fas fa-clipboard-check" style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "#989DA3" }}></i>
                                        }{formation['formation-name']}
                                    </div>
                                )}
                            </div>

                            {/*LANGUAGES*/}
                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['language'] + ".title"} tag={"span"} />
                                {this.props.consultant.content['language'].map((language, i) => <div key={Date.now() + "-" + language + i} style={{ display: 'block' }}>
                                    <div className="bloc-content">
                                        {language ? (
                                            <> {language['language-document'] ? <div
                                                style={{ display: "inline" }}
                                                onClick={(e) => this.downloadFieldImageConsultant({ name: "language-document", parent: "language", index: i })}
                                            ><i className="fas fa-language"
                                                title={this.props.translate('content.school.diploma.download')}
                                                style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "red" }}
                                                />
                                            </div>
                                                :
                                                <i className="fas fa-language" style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px' }}></i>
                                            }
                                                {language['language-name']}
                                                {language['language-level'] ?
                                                    <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{this.props.translate(`content.language.language-level.level.${language['language-level']}`)}</>
                                                    :
                                                    null
                                                }
                                                {language['language-test'] ?
                                                    <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{language['language-test']}</>
                                                    :
                                                    null
                                                }
                                                {language['language-result'] ?
                                                    <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{language['language-result']}</>
                                                    :
                                                    null
                                                }
                                            </>
                                        ) : (
                                            null
                                        )}
                                    </div>
                                </div>)}
                            </div>

                            {/*CERTIFICATION*/}
                            <div className="bloc">
                                <ContainerTranslation id={['content'] + "." + ['certification'] + ".title"} tag={"span"} />
                                {this.props.consultant.content['certification'].map((certification, i) => <div key={Date.now() + "-" + certification + i} style={{ display: 'block' }}>
                                    <div>

                                        {certification ? (
                                            <>
                                                <div className="bloc-content">
                                                    {certification['certification-document'] !== "" && certification['certification-document'] !== undefined ? <div
                                                        style={{ display: "inline" }}
                                                        onClick={(e) => this.downloadFieldImageConsultant({ name: "certification-document", parent: "certification", index: i })}
                                                    ><i className="fas fa-certificate"
                                                        title={this.props.translate('content.school.diploma.download')}
                                                        style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "red" }}
                                                        />
                                                    </div>
                                                        :
                                                        <i className="fas fa-certificate" style={{ verticalAlign: 'top', marginTop: '4px', marginLeft: '10px', color: "#989DA3" }}></i>
                                                    }
                                                    {certification['certification-name']}
                                                    {certification['certification-organisme'] ?
                                                        <><i className="fas fa-angle-right" style={{ verticalAlign: 'top', marginTop: '5px', marginLeft: '10px' }}></i>{certification['certification-organisme']}</>
                                                        :
                                                        null
                                                    }
                                                </div>
                                                <div style={{ marginTop: '0', marginLeft: '34px' }}>
                                                    <div style={{ display: 'inline-block' }}>
                                                        {certification['certification-start-date']}
                                                    </div>
                                                    <div style={{ float: 'right', display: 'inline-block' }}>
                                                        {certification['certification-end-date']}
                                                    </div>
                                                    <div style={{ marginTop: '4px' }}>
                                                        <div className="dot-date">
                                                        </div>
                                                        <div className="line-date">
                                                        </div>
                                                        <div className="dot-date">
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            null
                                        )}
                                    </div>
                                </div>)}
                            </div>


                            {/*HOBBIES*/}
                            {this.props.consultant.content.hobbies ?
                                <div className="bloc">
                                    <ContainerTranslation id={['content'] + "." + ['hobbies'] + ".title"} tag={"span"} />
                                    {this.props.consultant.content.hobbies.map(tool => <p className="bloc-tag" key={Date.now() + "-" + tool}>
                                        {tool}
                                    </p>)}
                                </div>
                                :
                                null
                            }
                        </div>

                    </div>


                </div>
            </div>
        </>

    )
  }
}

const mapStateToProps = state => ({
  consultant: state.consultant.consultant,
  message: state.consultant.message,
  projectMessage: state.project.message,
  documentId: state.project.documentId,
  list:state.user.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchConsultant,
  uploadPicture,
  createProjectForConsultant,
  downloadFieldImageConsultant,
  extractConsultant,
  getUsersList,
  submitField2Approver,
  approveField, 
    rejectField,
    expireField
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(ConsultantView)));









class SkillFields extends React.Component {


  render(){
    

    // props.skills
    // props.name
    // props.translate
    // props.users

    return (

      <div className="bloc">
        <ContainerTranslation id={`content.${this.props.name}.title`} tag="span" />
        {this.props.skills.map((skill, i) => {
          return (
            <SkillField
              key={`${Date.now()}-${this.props.name}-${i}`} 
              skill = {skill}
              translate = {this.props.translate}
              users = {this.props.users}
            />
          )
        })}
      </div>
    )
  }

}












class SkillField extends React.Component {


  render(){
    


    //props.skill.name
    //props.skill.fullName
    //props.skill.level
    //props.skill.yearOfExperience
    //props.skill.justification
    //props.skill.validationStatus
    //props.skill.actionhandlers
    //props.translate
    //props.users



    return (
        <div style={{ width: '90%', marginBlock: '30px', marginInline: 'auto' }}>
            <div className="button-bar">
                {this.props.skill.downloadDocument ?
                    <div
                        className="tab-btn"
                        onClick={(e) => this.props.skill.downloadDocument()}
                    >
                        download document
                    </div> : <div
                        className="tab-btn disabled"
                    >
                        download document
                    </div>
                }
                {this.props.skill.actionhandlers.approving ?
                    <div className="tab-btn small green" onClick={this.props.skill.actionhandlers.approving.action}>
                        {this.props.skill.actionhandlers.approving.label}
                    </div> : null
                }
                {this.props.skill.actionhandlers.rejecting ?
                    <div className="tab-btn small red" onClick={this.props.skill.actionhandlers.rejecting.action}>
                        {this.props.skill.actionhandlers.rejecting.label}
                    </div> : null
                }
                {this.props.skill.actionhandlers.approverPrompt ?
                    <div className="tab-btn" onClick={this.props.skill.actionhandlers.approverPrompt.action}>
                        {this.props.skill.actionhandlers.approverPrompt.label}
                    </div> : null
                }
            </div>
            <div    style={{ 
                borderWidth:'2px', 
                borderStyle:'solid', 
                borderColor:'black'}}>
            <div style={{height:'20px'}}>
            <p title={this.props.skill.fullName} style={{display:'inline-block',width:'70%',marginBlockStart:'0px',marginBlockEnd:'0px',overflowX:'auto'}}>
              {this.props.skill.name}
            </p>
          </div>
          <ValidationSubField validationInformation={this.props.skill.validationStatus} translate={this.props.translate}/>
          <div style={{marginBlock:'auto'}}>
            <p style={{fontSize:"12px", width:'15%', display:'inline-block' , textDecoration:'underline'}}>Expertise :</p>
            <p style={{fontSize:"12px", width:'35%', display:'inline-block'}}>{this.props.skill.level}</p>
            <p style={{fontSize:"12px", width:'40%', display:'inline-block' , textDecoration:'underline'}}>Year of experience :</p>
            <p style={{fontSize:"12px", width:'10%', display:'inline-block'}}>{this.props.skill.yearOfExperience}</p>
          </div>
          <p style={{fontSize:"12px", display:"block",marginBlock:'auto', textDecoration:'underline'}}>Justification</p>
          <p style={{display:"block",
                    color:"#989DA3",
                    fontSize:"12px",
                    lineHeight:"calc(16px + 8px)",
                    marginLeft:"0px",
                    paddingLeft:"0px",
                    marginBlock:'auto'
                  }}
          >
              {this.props.skill.justification}
          </p> 
            </div>
        </div>
    )
  }

}

class ValidationSubField extends React.Component {




  render(){
    
    let message = "";
    let icon = <></>;
    let color = "black";


    if (this.props.validationInformation === undefined){

    }
    else if (this.props.validationInformation.validationStatus === "document_validation_status_rejected"){

      message = this.props.translate('validation.field.rejected')
      .replace('<VALIDATOR>',this.props.validationInformation.user)
      .replace('<TIMESTAMP>',this.props.validationInformation.timestamp);

      color = '#CF3440';

      icon = <div className="validation-icon" style={{marginRight:"10px", marginLeft:"10px",color:color,fontSize:'smaller'}}>
              <i  className="fas fa-exclamation-triangle"></i>
            </div>
    }
    else if (this.props.validationInformation.validationStatus === "document_validation_status_submitted") {

      message = this.props.translate('validation.field.submitted')
      .replace('<VALIDATOR>',this.props.validationInformation.user)
      .replace('<TIMESTAMP>',this.props.validationInformation.timestamp);

      color = '#FF9100';

      icon = <div className="validation-icon" style={{marginRight:"10px", marginLeft:"10px",color:color,fontSize:'smaller'}}>
                  <i className="fas fa-solid fa-clock" ></i>
              </div>
    }
    else if (this.props.validationInformation.validationStatus === "document_validation_status_validated") {

        message = this.props.translate('validation.field.validated')
        .replace('<VALIDATOR>',this.props.validationInformation.user)
        .replace('<TIMESTAMP>',this.props.validationInformation.timestamp);

        color = '#99CC66';

        icon = <div className="validation-icon" style={{marginRight:"10px", marginLeft:"10px",color:color,fontSize:'smaller'}}>
                  <i  className="fas fa-solid fa-check" ></i>
                </div>  
    }
    else if (this.props.validationInformation.validationStatus === "document_validation_status_expired") {

        message = this.props.translate('validation.field.expired')
            .replace('<VALIDATOR>', this.props.validationInformation.user)
            .replace('<TIMESTAMP>', this.props.validationInformation.timestamp);

        color = '#CF3440';

        icon = <div className="validation-icon" style={{ marginRight: "10px", marginLeft: "10px", color: color, fontSize: 'smaller' }}>
            <i className="fas fa-hourglass-end" ></i>
        </div>
    }
    else {
        
    }


    return (

      <div>
          {icon}
          <p style={{display:'inline',fontSize:"10px",color:color}}>{message}</p>
      </div>

      )
    }

}